<template>
    <div>
        <rkm-row v-if="!isAmbulatorio">
            <rkm-col cols="6">
                <rkm-form-input-autocomplete
                    :repository="repositories.usuario"
                    :requestQueryStringParams="autocompleteRequestParams.usuario"
                    :searchFields="fields.autocomplete.usuario"
                    :validations="validations.usuario"
                    :text-field="(item) =>  item.cidadaoCns ? `${this.formatCns(item.cidadaoCns)} - ${item.cidadaoNome}` : item.cidadaoNome"
                    label="Profissional"
                    placeholder="Digite o nome ou número do conselho profissional"
                    v-model="model.cadastro.usuario"
                    uppercase
                    :disabled="model.exportacao"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="unidades"
                    label="Unidade"
                    show-default-option
                    text-field="nomeFantasia"
                    v-model="model.cadastro.unidadeId"
                    :validations="validations.unidade"
                    default-option-text="Selecione"
                    value-field="id"
                    :disabled="isDisabled"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    :options="infraestruturas"
                    label="Local de atendimento"
                    show-default-option
                    text-field="nome"
                    v-model="model.cadastro.infraestruturaId"
                    :validations="validations.infraestrutura"
                    default-option-text="Selecione"
                    value-field="id"
                    :disabled="model.cadastro.unidadeId == null"
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="Código da equipe"
                    :options="equipes"
                    text-field="descricao"
                    v-model="model.cadastro.equipeId"
                    :validations="validations.equipe"
                    value-field="id"
                    show-default-option
                    :disabled="model.cadastro.unidadeId == null || model.exportacao"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-select
                    label="Ocupação"
                    :options="ocupacoes"
                    text-field="codigoNome"
                    v-model="model.cadastro.ocupacaoId"
                    :validations="validations.ocupacao"
                    value-field="id"
                    show-default-option
                    :disabled="model.cadastro.unidadeId == null || model.exportacao"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-date-picker
                    label="Data"
                    :max-date="form.dataAtual"
                    v-model="model.cadastro.dataAtendimento"
                    :validations="validations.data"
                    right
                    :disabled="model.exportacao"
                    :maxDate="form.dataAtual"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="isAmbulatorio">

            <rkm-col cols="6">
                <rkm-form-input
                    label="Profissional"
                    v-model="agendamento.model.usuarioNome"
                    uppercase
                    disabled
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    label="Unidade"
                    v-model="agendamento.model.unidade"
                    uppercase
                    disabled
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-input
                    label="Local de atendimento"
                    v-model="agendamento.model.infraestrutura"
                    uppercase
                    disabled
                />
            </rkm-col>

            <rkm-col cols="6">
                <rkm-form-select
                    label="Código da equipe"
                    :options="equipes"
                    text-field="descricao"
                    v-model="model.cadastro.equipeId"
                    :validations="validations.equipe"
                    value-field="id"
                    show-default-option
                    :disabled="model.cadastro.unidadeId == null || model.exportacao"
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-form-input
                    label="Ocupação"
                    v-model="agendamento.model.ocupacao"
                    uppercase
                    disabled
                />
            </rkm-col>

            <rkm-col cols="3">
                <rkm-col>
                    <rkm-form-date-picker
                        label="Data"
                        v-model="agendamento.model.data"
                        disabled
                    />
                </rkm-col>
            </rkm-col>
        </rkm-row>

        <rkm-area title="Profissional auxiliar" no-margin-top>
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :repository="repositories.usuario"
                        :requestQueryStringParams="autocompleteRequestParams.usuarioAuxiliar"
                        :searchFields="fields.autocomplete.usuario"
                        :text-field="(item) =>  item.cidadaoCns ? `${this.formatCns(item.cidadaoCns)} - ${item.cidadaoNome}` : item.cidadaoNome"
                        label="Profissional"
                        placeholder="Digite o nome ou número do conselho profissional"
                        v-model="model.cadastro.usuarioAuxiliar"
                        uppercase
                        :disabled="model.exportacao"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="unidadesAuxiliar"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.cadastro.unidadeAuxiliarId"
                        :validations="validations.unidade"
                        default-option-text="Selecione"
                        value-field="id"
                        :disabled="isAuxiliarDisabled"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :options="infraestruturasAuxiliar"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.cadastro.infraestruturaAuxiliarId"
                        :validations="validations.infraestruturaAuxiliar"
                        default-option-text="Selecione"
                        value-field="id"
                        :disabled="model.cadastro.unidadeAuxiliarId == null"
                    />
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        label="Código da equipe"
                        :options="equipesAuxiliar"
                        text-field="descricao"
                        v-model="model.cadastro.equipeAuxiliarId"
                        :validations="validations.equipeAuxiliar"
                        value-field="id"
                        show-default-option
                        :disabled="model.cadastro.unidadeAuxiliarId == null || model.exportacao"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        label="Ocupação"
                        :options="ocupacoesAuxiliar"
                        text-field="codigoNome"
                        v-model="model.cadastro.ocupacaoAuxiliarId"
                        :validations="validations.ocupacaoAuxiliar"
                        value-field="id"
                        show-default-option
                        :disabled="model.cadastro.unidadeAuxiliarId == null || model.exportacao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-area>
    </div>
</template>

<script>
import { formats } from '@/mixins'
import { mapActions } from "vuex";
import moment from 'moment'

export default {
    data: () => ({
        unidades: [],
        infraestruturas: [],
        unidadesAuxiliar: [],
        infraestruturasAuxiliar: [],
        equipes: [],
        equipesAuxiliar: [],
        ocupacoes: [],
        ocupacoesAuxiliar: [],
    }),
    computed: {
        autocompleteRequestParams() {
            return {
                usuario: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    with_atencao_basica_permissao: this.enums.permissao.ATENDIMENTO_ODONTOLOGICO,
                    not_usuario_id: this.model.cadastro.usuarioAuxiliar && this.model.cadastro.usuarioAuxiliar.id
                        ? this.model.cadastro.usuarioAuxiliar.id
                        : null,
                },
                usuarioAuxiliar: {
                    with_not_regularized: true,
                    with_atencao_basica_equipe: true,
                    not_usuario_id: this.model.cadastro.usuario && this.model.cadastro.usuario.id
                        ? this.model.cadastro.usuario.id
                        : null,
                },
            }
        },
        validations() {
            return {
                usuario: {
                    required: true
                },
                unidade: {
                    required: true
                },
                infraestrutura: {
                    required: true
                },
                unidadeAuxiliar: {
                    required: true
                },
                infraestruturaAuxiliar: {
                    required: true
                },
                equipe: {
                    required: true
                },
                equipeAuxiliar: {
                    required: true
                },
                ocupacao: {
                    required: true
                },
                ocupacaoAuxiliar: {
                    required: true
                },
                data: {
                    required: true
                }
            }
        },
        fields() {
            return {
                autocomplete: {
                    usuario: [
                        { key: "cadastroCidadao.nome", searchable: true },
                        { key: "cadastroUsuario.registroNumero", searchable: true },
                    ],
                    cid: [{ key: "nome", searchable: true }],
                },
            }
        },
        isDisabled() {
            if(this.model.exportacao) {
                return true
            }
            return !this.model.cadastro.usuario
                || this.model.cadastro.usuario && !this.model.cadastro.usuario.id
        },
        isAuxiliarDisabled() {
            return !this.model.cadastro.usuarioAuxiliar
                || this.model.cadastro.usuarioAuxiliar && !this.model.cadastro.usuarioAuxiliar.id
        },
    },
    created() {

        if(this.model.cadastro.usuario.id && !this.isAmbulatorio) {
            this.getUnidades()
            this.getInfraestruturas()
            this.getEquipes()
            this.getOcupacoes()
        }

        if(this.model.cadastro.usuarioAuxiliar.id && !this.isAmbulatorio) {
            this.getUnidadesAuxiliar()
            this.getInfraestruturasAuxiliar()
            this.getEquipesAuxiliar()
            this.getOcupacoesAuxiliar()
        }

        if (this.isAmbulatorio) {
            this.equipes = this.agendamento.form.equipes

            this.model.atendimento.turnoId = this.agendamento.model.turnoId
                this.model.atendimento.localAtendimentoId = this.agendamento.model.atencaoBasicaLocalAtendimentoId

                if (this.agendamento.model.procedimentos) {

                    this.model.procedimentos = this.agendamento.model.procedimentos
                        .filter(procedimento => !procedimento.padrao && procedimento.usuario.id === this.agendamento.model.usuarioId)
                }

                if (this.agendamento.model.procedimento && this.agendamento.model.procedimento.id) {

                    const param = {
                        id: this.agendamento.model.procedimento.id,
                        nome: this.agendamento.model.procedimento.nome,
                        codigo: this.agendamento.model.procedimento.codigo,
                        padrao: true,
                        quantidade: 1,
                        origem: 'ambulatorio'
                    }

                    this.model.procedimentos.push(param)
                }

                if (this.agendamento.model.agendamentoId) {

                    this.model.atendimento.tipoAtendimentoId = this.enums.tipoAtendimento.CONSULTA_AGENDADA
                } else {

                    this.model.atendimento.tipoAtendimentoId = this.enums.tipoAtendimento.CONSULTA_NO_DIA
                }
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        setCadastro(field) {
            if (field === 'usuario'){
                this.model.cadastro.unidadeId = null
                this.model.cadastro.equipeId = null
                this.model.cadastro.ocupacaoId = null
                this.model.cadastro.dataUsuarioResponsavel = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
            } else if (field === 'infraestrutura') {
                this.model.cadastro.equipeId = null
                this.model.cadastro.ocupacaoId = null
                this.model.cadastro.dataUsuarioResponsavel = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
            }
            else {

                this.model.cadastro.equipeId = null
                this.model.cadastro.ocupacaoId = null
                this.model.cadastro.dataUsuarioResponsavel = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
            }
        },
        setAuxiliar(field) {
            if (field === 'usuario'){
                this.model.cadastro.unidadeAuxiliarId = null
                this.model.cadastro.equipeAuxiliarId = null
                this.model.cadastro.ocupacaoAuxiliarId = null
            } else if (field ===  'infraestrutura') {
                this.model.cadastro.equipeAuxiliarId = null
                this.model.cadastro.ocupacaoAuxiliarId = null
            }
            else {

                this.model.cadastro.equipeAuxiliarId = null
                this.model.cadastro.ocupacaoAuxiliarId = null
            }
        },
        getUnidades() {
            this.setLoading()
            this.repositories.atendimentoOdontologico.getUnidades({usuario_id: this.model.cadastro.usuario.id})
                .then(({ data }) => {
                    this.unidades = data
                    if (data.length === 1){
                        this.model.cadastro.unidadeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturas() {
            this.setLoading()
            this.repositories.atendimentoOdontologico.getInfraestruturas({
                usuario_id: this.model.cadastro.usuario.id,
                unidade_id: this.model.cadastro.unidadeId
            })
                .then(({ data }) => {
                    this.infraestruturas = data
                    if(data.length == 1) {
                        this.model.cadastro.infraestruturaId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getUnidadesAuxiliar() {
            this.setLoading()
            this.repositories.atendimentoOdontologico.getUnidades({usuario_id: this.model.cadastro.usuarioAuxiliar.id})
                .then(({ data }) => {
                    this.unidadesAuxiliar = data
                    if (data.length === 1){
                        this.model.cadastro.unidadeAuxiliarId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getInfraestruturasAuxiliar() {
            this.setLoading()
            this.repositories.atendimentoOdontologico.getInfraestruturas({
                usuario_id: this.model.cadastro.usuarioAuxiliar.id,
                unidade_id: this.model.cadastro.unidadeAuxiliarId
            })
                .then(({ data }) => {
                    this.infraestruturasAuxiliar = data
                    if(data.length == 1) {
                        this.model.cadastro.infraestruturaAuxiliarId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipes() {
            this.setLoading()
            this.repositories.atendimentoOdontologico.getEquipes({
                usuario_id: this.model.cadastro.usuario.id,
                infraestrutura_id: this.model.cadastro.infraestruturaId
            })
                .then(({ data }) => {
                    this.equipes = data
                    if (data.length === 1){
                        this.model.cadastro.equipeId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getEquipesAuxiliar() {
            this.setLoading()
            this.repositories.atendimentoOdontologico.getEquipes({
                usuario_id: this.model.cadastro.usuarioAuxiliar.id,
                infraestrutura_id: this.model.cadastro.infraestruturaAuxiliarId
            })
                .then(({ data }) => {
                    this.equipesAuxiliar = data
                    if (data.length === 1){
                        this.model.cadastro.equipeAuxiliarId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoes() {
            this.setLoading()
            this.repositories.atendimentoOdontologico.getOcupacoes({
                usuario_id: this.model.cadastro.usuario.id,
                infraestrutura_id: this.model.cadastro.infraestruturaId
            })
                .then(({ data }) => {
                    this.ocupacoes = data
                    if (data.length === 1){
                        this.model.cadastro.ocupacaoId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getOcupacoesAuxiliar() {
            this.setLoading()
            this.repositories.atendimentoOdontologico.getOcupacoesAuxiliar({
                usuario_id: this.model.cadastro.usuarioAuxiliar.id,
                infraestrutura_id: this.model.cadastro.infraestruturaAuxiliarId
            })
                .then(({ data }) => {
                    this.ocupacoesAuxiliar = data
                    if (data.length === 1){
                        this.model.cadastro.ocupacaoAuxiliarId = data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    watch: {
        'model.cadastro.usuario': function (usuario) {
            if (usuario && !this.isAmbulatorio) {
                this.getUnidades()
            }
            this.setCadastro('usuario')
        },
        'model.cadastro.usuarioAuxiliar': function(usuario) {
            if (usuario) {
                this.getUnidadesAuxiliar()
            }
            this.setAuxiliar('usuario')
        },
        'model.cadastro.unidadeId': function(unidadeId) {
            if (unidadeId && !this.isAmbulatorio) {
                this.getInfraestruturas()
            }
            this.setCadastro('unidade')
        },
        'model.cadastro.infraestruturaId': function (infraestruturaId) {
            if (infraestruturaId && !this.isAmbulatorio) {
                this.getEquipes()
                this.getOcupacoes()
            }
            this.setCadastro('infraestrutura')
        },
        'model.cadastro.unidadeAuxiliarId': function(unidadeId) {
            if (unidadeId) {
                this.getInfraestruturasAuxiliar()
            }
            this.setAuxiliar('unidade')
        },
        'model.cadastro.infraestruturaAuxiliarId': function (infraestruturaId) {
            if (infraestruturaId) {
                this.getEquipesAuxiliar()
                this.getOcupacoesAuxiliar()
            }
            this.setAuxiliar('infraestrutura')
        }
    },
    mixins: [ formats ],
    props: {
        repositories: { type: Object, required: false },
        model: { type: Object, required: false },
        enums: { type: Object, required: false },
        form: { type: Object, required: false },
        agendamento: { type: Object, required: false },
        isAmbulatorio: { type: Boolean, default: false },
    },
};
</script>
